module.exports = __webpack_public_path__ + "static/img/phone_img.7b836e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/phone_img.png
// module id = fI58
// module chunks = 1